import {
  ACT_INSTANCES_FETCH_BUILDINGS_INIT_ACTION,
  ACT_INSTANCES_FETCH_BUILDINGS_SUCCESS_ACTION,
  ACT_INSTANCES_FILTER_BUILDINGS_INIT_ACTION,
  ACT_INSTANCES_FILTER_BUILDINGS_SUCCESS_ACTION,
  ACT_INSTANCES_UPDATE_MAIN_BUILDINGS_FILTERS_ACTION,
  ACT_INSTANCES_SET_SELECTED_BUILDING, ACT_INSTANCES_SET_BUILDINGS_PAGE_INFO,
} from '../../constants/actions';

const defaultState = {
  isLoadingBuildings: false,
  didLoadBuildings: false,
  buildingsList: [],
  filteredBuildings: [],
  mainFilters: [],
  isLoadingMainBuildings: false,
  selectedBuilding: undefined,
  currentPageInfo: {
    from: 0,
    to: 0,
    total: 0,
    last_page: 0,
    per_page: 30,
  },
};

const buildingsReducer = (state = defaultState, action) => {
  switch (action.type) {
    case ACT_INSTANCES_FETCH_BUILDINGS_INIT_ACTION:
      return {
        ...state,
        isLoadingBuildings: true,
        didLoadBuildings: false,
        buildingsList: [],
      };
    case ACT_INSTANCES_FETCH_BUILDINGS_SUCCESS_ACTION:
      return {
        ...state,
        isLoadingBuildings: false,
        didLoadBuildings: true,
        buildingsList: action.payload,
      };
    case ACT_INSTANCES_FILTER_BUILDINGS_INIT_ACTION:
      return {
        ...state,
        isLoadingMainBuildings: true,
        filteredBuildings: [],
      };
    case ACT_INSTANCES_FILTER_BUILDINGS_SUCCESS_ACTION:
      return {
        ...state,
        isLoadingMainBuildings: false,
        filteredBuildings: action.payload,
      };
    case ACT_INSTANCES_UPDATE_MAIN_BUILDINGS_FILTERS_ACTION:
      return {
        ...state,
        mainFilters: action.payload,
      };
    case ACT_INSTANCES_SET_SELECTED_BUILDING:
      return {
        ...state,
        selectedBuilding: action.payload,
      };
    case ACT_INSTANCES_SET_BUILDINGS_PAGE_INFO:
      return {
        ...state,
        currentPageInfo: action.payload,
      };
    default:
      return state;
  }
};

export default buildingsReducer;
